import TextDisplay from 'src/components/Review/TextDisplay';
import ValueTaxDataTable from 'src/components/util/ValueTaxDataTable';
import formatCurrency from 'src/util/formatCurrency';

/**
* ValueTaxInfo component displays the value and tax information for a property or vehicle.
*
* @param {string} type   - The type of asset to display information for. Can be 'vehicle' or 'property'.
* @param {Object} info   - The value and tax information to display.
@component
@example
const info = {
assets: [
{
  name: 'Asset 1',
  value: '$100,000',
},
{
  name: 'Asset 2',
  value: '$200,000',
},
],
currMarketValue: '$500,000',
amountOfferedInSettlement: '$400,000',
amountToBeRefunded: '$50,000',
}
return (
<ValueTaxInfo type="residential" info={info} />
)
*/
export default function ValueTaxInfo({ type, info, className = '' }) {
  return (
    <div className={`flex flex-wrap gap-4 ${className}`}>
      {type === 'vehicle' ? (
        <TextDisplay
          className="w-full"
          field="Total Paid"
          value={info?.amountPaid ? formatCurrency(info?.amountPaid) : ''}
        />
      ) : (
        <>
          <ValueTaxDataTable className="w-full" rows={info.assets} />
          <TextDisplay
            className="w-full"
            field="Current Year Market Value of Property"
            value={info?.currMarketValue ? formatCurrency(info?.currMarketValue) : ''}
          />
        </>
      )}

      <TextDisplay
        className="w-full"
        field="Amount Owner Offers in Settlement"
        value={info.amountOfferedInSettlement ? formatCurrency(info.amountOfferedInSettlement) : ''}
      />
      <TextDisplay
        className="w-full"
        field="Amount to be Abated/Refunded"
        value={info.amountToBeRefunded ? formatCurrency(info.amountToBeRefunded) : ''}
      />
    </div>
  );
}
